import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { FormGroup, Input, Row, Col, Button } from "reactstrap";

// helpers
import { showMessage } from "../../../helpers/message";

// api
import analiseboletim_api from "../../../api/analiseboletim_api.js";

export default function AnaliseDefesaPrevia({ boletimVistoria, setshowLoading, handleReturn }) {

    const { register, getValues } = useForm({ mode: "onBlur" });

    const handleExecutarAcao = (acao) => {
        let data = getValues();

        let json_submit = {
            boletimVistoria_Id: boletimVistoria.boletimVistoria_Id,
            situacaoAnalise: boletimVistoria.situacaoAnalise,
            acao: acao,
            observacao: data.observacao
        }

        setshowLoading(true);
        analiseboletim_api.post(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { handleReturn(true) });
            }
        })

    }

    return (
        <>
            <h5 className="subtitleCardInfo">Análise de Defesa Prévia</h5>
            <Row className="mb-4">
                <Col lg="12" md="12" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Observações</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="text"
                            name="observacao"
                            innerRef={register({ required: false })}
                        />
                    </FormGroup>
                </Col>
                <Col lg="12" md="12" sm="12">
                    <Button color="success" onClick={() => handleExecutarAcao("Aprovar Defesa")}>
                        Aprovar Defesa
                    </Button>
                    <Button color="danger" onClick={() => handleExecutarAcao("Reprovar Defesa")}>
                        Reprovar Defesa
                    </Button>
                </Col>
            </Row>
        </>
    );
}
